import { HttpHeaders, HttpClient } from "@angular/common/http";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { Injectable } from "@angular/core";

import { IApiRequest, IApiresponse } from "src/app/_models";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
  ActiveLocationForAssignResponse,
  AssignLocationToEmployeesRequest,
  BulkActionOnLocationRequest,
  EmployeeListForLocationAssignmentResponse,
  GetEmployeeForLocationAssignmentRequest,
  GetLocationByLocationIdRequest,
  GetLocationByLocationIdsRequest,
  GetLocationByOrgIdAndStatusRequest,
  GetLocationListForGridRequest,
  GetLocationShortDetailsResponse,
  LocationCsvRecordExport,
  LocationListForGridResponse,
  LocationRequest,
  LocationResponse,
} from "../../_models/location/location";
import { ExcelExportService } from "../common/excel-export.service";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  httpHeaders: HttpHeaders;
  constructor(
    private http: HttpClient,
    private claimsHeaderService: ClaimsHeaderService,
    private excelExportService: ExcelExportService
  ) {}

  AddLocation(
    requestInfo: IApiRequest<LocationRequest>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}AddLocation`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  UpdateLocation(
    requestInfo: IApiRequest<LocationRequest>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}UpdateLocation`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  AssignLocationToEmployees(
    requestInfo: IApiRequest<AssignLocationToEmployeesRequest>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}AssignLocationToEmployees`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetEmployeeForLocationAssignment(
    requestInfo: IApiRequest<GetEmployeeForLocationAssignmentRequest>
  ): Observable<IApiresponse<EmployeeListForLocationAssignmentResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<
      IApiresponse<EmployeeListForLocationAssignmentResponse>
    >(`${environment.billingApiUrl}GetEmployeeForLocationAssignment`, body, {
      headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
    });
  }

  GetLocationByLocationId(
    requestInfo: IApiRequest<GetLocationByLocationIdRequest>
  ): Observable<IApiresponse<LocationResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<LocationResponse>>(
      `${environment.billingApiUrl}GetLocationByLocationId`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetLocationByLocationIds(
    requestInfo: IApiRequest<GetLocationByLocationIdsRequest>
  ): Observable<IApiresponse<LocationResponse[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<LocationResponse[]>>(
      `${environment.billingApiUrl}GetLocationByLocationIds`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetLocationByOrgIdAndStatus(
    requestInfo: IApiRequest<GetLocationByOrgIdAndStatusRequest>
  ): Observable<IApiresponse<LocationResponse[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<LocationResponse[]>>(
      `${environment.billingApiUrl}GetLocationByOrgIdAndStatus`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetLocationListForGrid(
    requestInfo: IApiRequest<GetLocationListForGridRequest>
  ): Observable<IApiresponse<LocationListForGridResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<LocationListForGridResponse>>(
      `${environment.billingApiUrl}GetLocationListForGrid`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetActiveLocations(
    requestInfo: IApiRequest<GetLocationByOrgIdAndStatusRequest>
  ): Observable<IApiresponse<GetLocationShortDetailsResponse[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<GetLocationShortDetailsResponse[]>>(
      `${environment.billingApiUrl}GetActiveLocations`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetLocationShortDetailsByOrgIdAndStatus(
    requestInfo: IApiRequest<GetLocationByOrgIdAndStatusRequest>
  ): Observable<IApiresponse<GetLocationShortDetailsResponse[]>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<GetLocationShortDetailsResponse[]>>(
      `${environment.billingApiUrl}GetLocationShortDetailsByOrgIdAndStatus`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  ExportData(
    exportedData: any[],
    excelFileName: string,
    addErrorColumn: boolean
  ) {
    let mappedData: LocationCsvRecordExport[] = [];
    for (let i = 0; i < exportedData.length; i++) {
      let recordExport = new LocationCsvRecordExport();
      recordExport.LocationName = exportedData[i].locationName;
      recordExport.LocationCode1 = exportedData[i].locationCode1;
      recordExport.LocationCode2 = exportedData[i].locationCode2;
      if (addErrorColumn) {
        recordExport.Error = exportedData[i].error;
      }

      mappedData.push(recordExport);
    }

    this.excelExportService.exportAsExcelFile(mappedData, excelFileName);
  }

  BulkActionOnLocation(
    requestInfo: IApiRequest<BulkActionOnLocationRequest>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}BulkActionOnLocation`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  AddUpdateLocationRange(
    requestInfo: IApiRequest<LocationRequest[]>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.billingApiUrl}AddUpdateLocationRange`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetListForGrid(
    requestInfo: IApiRequest<GetLocationListForGridRequest>
  ): Observable<IApiresponse<LocationListForGridResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<LocationListForGridResponse>>(
      `${environment.billingApiUrl}GetListForGrid`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  GetEmployeeListForLocationAssignment(
    requestInfo: IApiRequest<GetEmployeeForLocationAssignmentRequest>
  ): Observable<IApiresponse<EmployeeListForLocationAssignmentResponse>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<
      IApiresponse<EmployeeListForLocationAssignmentResponse>
    >(
      `${environment.billingApiUrl}GetEmployeeListForLocationAssignment`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

  
  UpdateLocationPreference(locationLabel): Observable<IApiresponse<boolean>> {
    return this.http.get<IApiresponse<boolean>> (
      `${environment.billingApiUrl}UpdateLocationPreference?locationLabel=` + locationLabel,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }
}
